import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM7 10.82C5.84 10.4 5 9.3 5 8V7h2v3.82zm8 .18c0 1.65-1.35 3-3 3s-3-1.35-3-3V5h6v6zm4-3c0 1.3-.84 2.4-2 2.82V7h2v1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 11c0 1.65 1.35 3 3 3s3-1.35 3-3V5H9v6z",
  opacity: ".3"
})), 'EmojiEventsTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EmojiEventsTwoTone.js
// module id = 3337
// module chunks = 2